


















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
@Component({
  components: {
  }
})
export default class EntityEditPage extends Vue {
  @Prop({
    required: true
  }) public entityName!: string;

  @Prop({
    required: true
  }) public pageTitle!: string;

  public id!: number;
  public datarow!: any;
  public pageReady = false;

  constructor() {
    super();
  }

  @Emit('onDatarowAvailable')
  public onDatarowAvailable($event: any) {
    // silence is golden.
  }

  async mounted() {
    this.id = Number(this.$route.params.id);
    if (!Number.isNaN(this.id)) {
      this.datarow = await Vue.$svc.entityGet(this.entityName, this.id);
    }
    else {
      this.datarow = {};
    }
    this.pageReady = true;
    this.onDatarowAvailable(this.datarow);
  }

  async deleteDatarow() {
    const confirmDelete = await Vue.$svc.displayConfirm('Confermare eliminazione?', 'Confermi di voler eliminare questo elemento? l\'operazione è irreversibile');
    if (confirmDelete) {
      const ok = await Vue.$svc.entityDelete(this.entityName, this.id);
      if (ok) {
        this.$router.go(-1);
      }
    }
  }

  async saveDatarow() {
    let ok = false;
    if (this.datarow.id > 0) {
      ok = await Vue.$svc.entityUpdate(this.entityName, this.datarow);
    }
    else {
      ok = await Vue.$svc.entitySave(this.entityName, this.datarow);
    }
    if (ok) {
      this.$router.go(-1);
    }
    else console.info('-> save NOT OK!');
  }

  close() {
    this.$router.go(-1);
  }
}
